<div class="dialog-container">
	<huge-row>
		<mat-col> <h3 mat-dialog-title> Edit Merchant and Terminal ID </h3></mat-col>
		<div
			class="close"
			(click)="close()"
			lines="none"
			button="true">
			<i class="material-icons openIcon">close</i>
		</div>
	</huge-row>
	@if (saving) {
<div
	
		class="loader">
		<mat-spinner></mat-spinner>
	</div>
}
	@if (!saving) {
<div>
		<form [formGroup]="deviceForm">
			<mat-dialog-content class="field-wrapper">
				<mat-form-field class="default-input field">
					<mat-label>Terminal ID</mat-label>
					<input
						matInput
						formControlName="terminalId" />
				</mat-form-field>
				<mat-form-field class="default-input field">
					<mat-label>Merchant Name</mat-label>
					<input
						matInput
						formControlName="merchantName" />
				</mat-form-field>
				<mat-form-field class="default-input field">
					<mat-label>Serial Number</mat-label>
					<input
						matInput
						formControlName="serialNumber" />
				</mat-form-field>
			</mat-dialog-content>
		</form>
		<mat-dialog-actions>
			<button
				mat-button
				(click)="save()">
				Save
			</button>
		</mat-dialog-actions>
	</div>
}
</div>
